import { INVOICE_LIST_FAIL, INVOICE_LIST_REQUEST, INVOICE_LIST_SUCCESS, INVOICE_LIST_UPDATE } from "../constats/invoice.constant";

export const invoiceListReducer = (state={}, action) => {
    switch (action.type) {
        case INVOICE_LIST_REQUEST:
            return {
                loading: true
            };
        case INVOICE_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case INVOICE_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        case INVOICE_LIST_UPDATE:
            return {
                ...state,
                data: {
                    ...state.data,
                    data: state.data.data.map(element =>
                        element.id === action.payload.id ? { ...action.payload } : element
                    )
                }
            };
        default:
            return state;
    }
}